angular.module('SpidApp')

.factory('BusinessDayService',
		['Restangular', 'BusinessDay',
function (Restangular,   BusinessDay) {
	var BusinessDayService = {
		getByAgencyId: function (agencyId) {
			if (agencyId === null || agencyId === undefined) {
				throw 'BusinessDay::getByAgencyId() - Missing parameters'
			}

			return Restangular.one('agencies', agencyId).all('business-days').getList().then(function(businessDayDatas) {
				return _.map(businessDayDatas, function (businessDayData) {
					return new BusinessDay(businessDayData)
				})
			})
		},

		// @params
		//   isoDate : String('YYY-MM-DD')
		getByAgencyIdAndByDate: function (agencyId, isoDate) {
			if (agencyId === null || agencyId === undefined || !isoDate) {
				throw 'BusinessDay::getByAgencyIdAndByDate() - Missing parameters'
			}

			var almostIsoRegex = /(\d{4})-(\d{2})-(\d{2})/
			if (!isoDate.match(almostIsoRegex)) {
				throw 'BusinessDay::getByAgencyIdAndByDate() - Malformed parameters'
			}

			return Restangular.one('agencies', agencyId).one('business-days', isoDate).get().then(function (businessDayData) {
				return new BusinessDay(businessDayData)
			})
		},

		save: function (agencyId, businessDay) {
			if (!agencyId || !businessDay) {
				throw 'BusinessDayService::save() - Missing parameters'
			}
			return Restangular.one('agencies', agencyId).all('business-days').post(businessDay)
		}
	}

	return BusinessDayService
}])